module.exports = __webpack_public_path__ + "assets/images/project/cover/cover.png?v=955ffd00";